<template>
  <v-layout column v-if="researchQuestionInputState.showSection">
    <span class="ml-5 input-title">
      {{ $t('ai.questionInput.welcomeBanner') }}
      <a :href="blogAIGenUrl" target="_blank">More details <v-icon class='input-external-link-icon'>open_in_new</v-icon></a>
    </span>
    <v-layout align-center>
      <SearchAISubtitle
        :isResearchQuestionInput="true"
        :researchQuestionPlaceholder="$t('ai.questionInput.questionPlaceholder')"
        @handleRQonEnter="processResearchQuestion"
        @handleRQonClick="handleResetErrorMessage"
        ></SearchAISubtitle>
      <CustomButton text="Go" @onClick="processResearchQuestion" :isDisabled="disableInputBtn"></CustomButton>
    </v-layout>
    <v-flex class="ml-5 mt-4 input-example-container">
      <span><b>{{ $t('ai.questionInput.examples.title') }}</b></span>
      <ul class="ml-4">
        <li>{{ $t('ai.questionInput.examples.exampleOne') }}</li>
        <li>{{ $t('ai.questionInput.examples.exampleTwo') }}</li>
        <li>{{ $t('ai.questionInput.examples.exampleThree') }}</li>
      </ul>
    </v-flex>
    <v-flex class="mt-5 ml-5">
      <img src="../../../../static/gif/ai-explaination.gif">
    </v-flex>
  </v-layout>
</template>

<script>
import SearchAISubtitle from './SearchAISubtitle.vue'
import AnimatedText from '../utils/AnimatedText.vue'
import CustomButton from '../utils/buttons/CustomButton.vue'
import { blogAIGenUrl } from '../../../utils/constants'
import '../../../style/_variables.scss'

export default {
  name: 'ResearchQuestionInput',
  components: { CustomButton, SearchAISubtitle, AnimatedText },
  data () {
    return {
      blogAIGenUrl: blogAIGenUrl
    }
  },
  computed: {
    researchQuestionInput: {
      get () { return this.$store.state.searchAiState.researchQuestionInput },
      set (value) { this.$store.commit('setResearchQuestionInput', value) }
    },
    researchQuestionInputState: {
      get () { return this.$store.getters.getResearchQuestionInputState }
    },
    disableInputBtn: {
      get () { return this.$store.getters.disableInputBtn }
    }
  },
  methods: {
    handleResetErrorMessage () {
      this.$store.commit('setShowErrorMessageRQInput', false)
    },
    processResearchQuestion () {
      this.$store.dispatch('processResearchQuestion')
    }
  }
}
</script>

<style scoped lang="scss">
.input {
  &-title {
    font-weight: bold;
  }
  &-external-link-icon {
      font-size: 16px;
  }
  &-example {
    &-container {
      color: $grey-800;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/searchAi/ResearchQuestionInput.vue